import { request } from './auth-actions'
import FaroeIslandsAddressServiceApi from '../../api/faroe-islands-address-service-api'

export const validateAddress = (street, postalCode) => dispatch => {
  return dispatch(
    request(FaroeIslandsAddressServiceApi.validateAddress, {
      street: ((/^(\d*.*?) ?[\d].*?$/g.exec(street) || [])[1] || street).trim(),
      postalCode,
    }),
  )
}
